import { render, staticRenderFns } from "./TaskWorkers.vue?vue&type=template&id=a0d03ebe&scoped=true&"
import script from "./TaskWorkers.vue?vue&type=script&lang=js&"
export * from "./TaskWorkers.vue?vue&type=script&lang=js&"
import style0 from "./TaskWorkers.vue?vue&type=style&index=0&id=a0d03ebe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d03ebe",
  null
  
)

export default component.exports